import type { AxiosError } from "axios";
import useSWR, { type SWRResponse } from "swr";
import type { CountryType, Nullable } from "../../../@types/generic";
import { numberToString } from "../../../helpers/formatters/values";
import { useCountry } from "../../../hooks/useCountry";
import { QUERY_NAME_LOCATION } from "../../cacheKeys";
import { fetcher, isAxiosError } from "../index";
import type { Location } from "../types/locations";

const fetchLocation = async (
    code: string,
    country: CountryType
): Promise<Nullable<Location>> =>
    fetcher<Location>(
        { path: `/locations/${code.toUpperCase()}/` },
        { country }
    )
        .then(({ data }) => data)
        .catch((error: Error | AxiosError) => {
            if (isAxiosError(error) && error.status === 404) {
                return null;
            }

            return Promise.reject(error);
        });

export const useLocation = (
    code: Nullable<string> | undefined
): SWRResponse<Nullable<Location>> => {
    const country = useCountry();
    return useSWR(
        numberToString(code) !== ""
            ? [QUERY_NAME_LOCATION, code, country]
            : null,
        () => fetchLocation(code as string, country)
    );
};
